var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.products),function(el){return [_c('product-card',{staticClass:"card",attrs:{"productIcon":el.image,"title":el.name,"content":el.content,"url":el.link}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }